"use client";

import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { useTranslations } from "next-intl";
import { useVacanciesData } from "../../hooks/useVacanciesData";
import VacanciesList from "./vacancies-list";

const Vacancies = () => {
  const t = useTranslations("vacancy");
  const { vacancies } = useVacanciesData();

  return (
    <Container>
      <div className={S.content}>
        <h2 className={S.title}>{t("vacanciesTitle")}</h2>
        {vacancies.map(({ title, data }) => (
          <VacanciesList title={title} data={data} key={title} />
        ))}
        <h3 className={S.email}>
          {t.rich("email", {
            highlight: chunks => <a href="mailto:hr@aquaart.ru">{chunks}</a>,
          })}
        </h3>
      </div>
    </Container>
  );
};

export default Vacancies;
